import React, { Component } from 'react';
import { TrackerJavascriptVariable } from '../../../../domain/tracker/variable/TrackerVariable';
import FormicaLabel from '../../../custom/FormicaLabel';
import Editor from '@monaco-editor/react';

class TrackerJavascriptVariableComponent extends Component<Props> {
  public render() {
    const { variable } = this.props;
    return (
      <div className={'border-b py-5'}>
        <div className={'flex flex-col gap-y-1'}>
          <FormicaLabel label={'Code'} />
          <Editor language='javascript' value={variable.code} height={'300px'} onChange={this.onChangeCode} />
        </div>
      </div>
    );
  }

  private onChangeCode = (e: string | undefined) => {
    const { variable, onChange } = this.props;
    variable.code = e || '';
    onChange(variable);
  };
}

interface Props {
  variable: TrackerJavascriptVariable;
  onChange: (variable: TrackerJavascriptVariable) => void;
}

export default TrackerJavascriptVariableComponent;
